/**
 * Fonds de carte communs (direct, relecture, enquête RDV). Esri uniquement :
 * Carto exige désormais une clé API (tuiles « API KEY REQUIRED »). Hôte déjà
 * autorisé par les CSP (static/nginx.conf, Helmet).
 */
const ESRI = 'https://server.arcgisonline.com/ArcGIS/rest/services';

// Le site est en no-referrer ; les serveurs de tuiles reçoivent l'origine seule (jamais le chemin).
export const TILE_REFERRER = 'strict-origin-when-cross-origin';

export const MAP_TILES = Object.freeze({
    plan: { url: `${ESRI}/World_Street_Map/MapServer/tile/{z}/{y}/{x}`, attribution: 'Tiles © Esri' },
    satellite: { url: `${ESRI}/World_Imagery/MapServer/tile/{z}/{y}/{x}`, attribution: 'Tiles © Esri' },
    satelliteLabels: { url: `${ESRI}/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}`, attribution: '© Esri' },
});

/** Options Leaflet d'une couche de MAP_TILES. */
export const tileOptions = (name, extra = {}) => ({
    maxZoom: 19,
    attribution: MAP_TILES[name].attribution,
    referrerPolicy: TILE_REFERRER,
    ...extra,
});
